import { useMemo, useState } from "react";
import type { PayrollTeam } from "@/payroll/roster/types";
import { validTeamIds } from "./utils";

export const useTeamSelection = (
  businessId: string | null,
  // null means choices are temporarily unavailable, not removed.
  teams: readonly PayrollTeam[] | null,
) => {
  const [selection, setSelection] = useState<{
    businessId: string | null;
    ids: string[];
  }>({ businessId, ids: [] });
  const ids = useMemo(
    () =>
      selection.businessId !== businessId
        ? []
        : teams === null
          ? selection.ids
          : validTeamIds(selection.ids, teams),
    [selection, businessId, teams],
  );
  if (
    selection.businessId !== businessId ||
    selection.ids.join() !== ids.join()
  )
    setSelection({ businessId, ids });
  return {
    teamIds: ids,
    setTeamIds: (next: string[]) =>
      setSelection({ businessId, ids: validTeamIds(next, teams ?? []) }),
  };
};
